/**
 * "Part of the CTM Partner Program agency network" - the lockup at the foot of every
 * page (Figma `3883:70490`).
 *
 * It is inlined from a committed SVG for the same reason `Logo` is, and with the same
 * rule: **its colour is not ours to change.** The export keeps its `#A0A0A0`, so it is
 * not on the `currentColor` pipeline the icons use. It is somebody else's mark.
 */
import mark from './ctm-partner.svg?raw';

/**
 * The committed export carries its own `role="img"`, which left a second image node
 * inside the named wrapper with no name of its own - `svg-img-alt` on every page of the
 * site. The wrapper is what should be announced, so the inner one is hidden rather than
 * named twice.
 *
 * Done here rather than by editing the asset: the file is somebody else's mark, and an
 * export that gets refreshed would quietly bring the role back.
 */
const inert = mark.replace(/<svg\b/, '<svg aria-hidden="true" focusable="false"');

export function PartnerMark({ className }: { className?: string }) {
  return (
    <span
      role="img"
      aria-label="Part of the CTM Partner Program agency network"
      className={`inline-block [&>svg]:h-full [&>svg]:w-full ${className ?? ''}`}
      // Build-time constant from a committed file, not user input.
      dangerouslySetInnerHTML={{ __html: inert }}
    />
  );
}
